import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Claim from '../../entities/customercare/claim'
import Ajax from '../../../lib/ajax'
import Util from '../../../lib/util'

interface ClaimState extends ListState<Claim>{
    editModel: Claim;
    dashClaims: Array<any>;
    dashQuerys: Array<any>;
    dashStates: Array<any>;
    dashModels: Array<any>;
    dashYears: Array<any>;
    states: Array<any>;
    models: Array<any>;
    years: Array<any>;
    complaints: Array<any>;
    evolutionClaims: Array<any>;
    evolutionQuerys: Array<any>;
    evolutionComplaints: Array<any>;
    widgetClaims: any;
    widgetQuerys: any;
    filename: string;
}
class ClaimModule extends ListModule<ClaimState,any,Claim>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize: 10,
        list: new Array<Claim>(),
        loading:false,
        editModel: new Claim(),
        activeList: new Array<Claim>(),
        dashClaims: new Array<any>(),
        dashQuerys: new Array<any>(),
        dashStates: new Array<any>(),
        dashModels: new Array<any>(),
        dashYears: new Array<any>(),
        states: new Array<any>(),
        models: new Array<any>(),
        years: new Array<any>(),
        complaints: new Array<any>(),
        evolutionClaims: new Array<any>(),
        evolutionQuerys: new Array<any>(),
        evolutionComplaints: new Array<any>(),
        widgetClaims: {},
        widgetQuerys: {},
        filename: '',
        path: 'claims'          
    }
    actions = Util.extend(true, this.base_actions, {
        //extra actions
        async export(context: ActionContext<ClaimState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/claims/export', { params: payload.data }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            context.state.filename = reponse.data.result.filename;
            return reponse.data.result.filename;
        },
        async process(context: ActionContext<ClaimState, any>, payload: any) {
            context.state.loading = true;
            let response = await Ajax.post('/api/claims/process', payload.data).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            return response.data.result;
        },
        async close(context: ActionContext<ClaimState, any>, payload: any) {
            context.state.loading = true;
            let response = await Ajax.post('/api/claims/close', payload.data).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            return response.data.result;
        },
        async getDashClaims(context: ActionContext<ClaimState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/dash-claims', { params: payload.data }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            context.state.dashClaims = reponse.data.result;
            return true;
        },
        async getDashQuerys(context: ActionContext<ClaimState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/dash-querys', { params: payload.data }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            context.state.dashQuerys = reponse.data.result;
            return true;
        },
        async getDashEvolutionClaims(context: ActionContext<ClaimState, any>, payload: any) {
            context.state.loading = true;
            //context.state.evolutionClaims = [{ name: 'Abierto', data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] }, { name: 'En proceso', data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] }, { name: 'Cerrado', data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] }];
            let reponse = await Ajax.get('/api/evolution-claims', { params: payload.data }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            context.state.evolutionClaims = reponse.data.result;
            return true;
        },
        async getDashEvolutionQuerys(context: ActionContext<ClaimState, any>, payload: any) {
            context.state.loading = true;
            //context.state.evolutionQuerys = [{ name: 'Abierto', data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] }, { name: 'En proceso', data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] }, { name: 'Cerrado', data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] }];
            let reponse = await Ajax.get('/api/evolution-querys', { params: payload.data }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            context.state.evolutionQuerys = reponse.data.result;
            return true;
        },
        async getDashEvolutionComplaints(context: ActionContext<ClaimState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/evolution-complaints', { params: payload.data }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            context.state.evolutionComplaints = reponse.data.result.list;
            context.state.complaints = reponse.data.result.complaints;
            return true;
        },
        async getWidgetClaims(context: ActionContext<ClaimState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/widget-claims', { params: payload.data }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            context.state.widgetClaims = reponse.data.result;
            return context.state.widgetClaims;
        },
        async getWidgetQuerys(context: ActionContext<ClaimState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/widget-querys', { params: payload.data }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            context.state.widgetQuerys = reponse.data.result;
            return context.state.widgetQuerys;
        },
        async getDashClaimStates(context: ActionContext<ClaimState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/dash-claim-states', { params: payload.data }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            context.state.dashStates = reponse.data.result.list;
            context.state.states = reponse.data.result.states;
            return context.state.dashStates;
        },
        async getDashModels(context: ActionContext<ClaimState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/dash-models', { params: payload.data }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            context.state.dashModels = reponse.data.result.list;
            context.state.models = reponse.data.result.models;
            return context.state.dashModels;
        },
        async getDashYears(context: ActionContext<ClaimState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/dash-years', { params: payload.data }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            context.state.dashYears = reponse.data.result.list;
            context.state.years = reponse.data.result.years;
            return context.state.dashYears;
        },
    });
    mutations = Util.extend(true, this.base_mutations, {
        //extra mutations
        edit(state: ClaimState, model: Claim) {
            state.editModel = model;            
        }, 
        new(state: ClaimState, model: Claim) {
            state.editModel = Object.assign({});
            state.editModel.dealer_id = 1;
            state.editModel.manufacturer_id = 1;
            state.editModel.type_id = Util.abp.list.get('T_CLAIM', 'R').id;
            state.editModel.emails = []
        },
    });
}
const claimModule=new ClaimModule();
export default claimModule;
